import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    body {
        -webkit-font-smoothing: antialiased;
    }

    #tooltip-wrapper, #toast-wrapper {
        bottom: 0;
        left: 0;
        position: fixed;
        z-index: 99;
    }

    #toast-wrapper {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        width: 100%;
        margin-bottom: 32px;
    }
`;
